<template lang="pug">
  v-dialog(:value="value" max-width="468" @input="closeModal")
    v-card
      v-card-title.headline.justify-space-between
        | Change password
      v-card-text
        v-form(ref="form")
          v-text-field(
            v-model="model.password"
            label='Password'
            :rules="[RULES.REQUIRED, RULES.SAME_AS(model.password_confirmation)]"
            :error="formErrors.hasError('password')"
            :error-messages="formErrors.fields.password"
            @keyup="$refs.form.validate()"
          )
          v-text-field(
            v-model="model.password_confirmation"
            label='Password Confirmation'
            :rules="[RULES.REQUIRED, RULES.SAME_AS(model.password)]"
            :error="formErrors.hasError('password_confirmation')"
            :error-messages="formErrors.fields.password_confirmation"
            @keyup="$refs.form.validate()"
          )
          .d-flex.mt-4
            v-btn(color="primary" outlined @click="closeModal").ml-auto.mr-3 Cancel
            v-btn(color="primary" depressed @click="save" :disabled="loading") Save


</template>

<script>
import FormErrors from "@/util/form-errors";
import ErrorMixin from "@/mixins/errors.mixin";
import { REQUIRED, SAME_AS } from "@/util/validation-rules";
import {ChangePasswordModel} from "@/app/exercise/modules/users/core/models/ChangePasswordModel";
import {UsersService} from "@/app/exercise/modules/users/core/users-service";

export default {
  props: {
    value: {
      type: Boolean,
    },
    user: Object
  },

  mixins: [ErrorMixin],

  data: () => ({
    svc: null,
    formErrors: null,
    model: new ChangePasswordModel(),
    deleteConfirmationModal: false,
    loading: false,
    RULES: {
      REQUIRED,
      SAME_AS
    },
  }),

  created() {
    this.init()
  },

  methods: {
    init() {
      this.svc = new UsersService();
      this.formErrors = new FormErrors();
    },

    resetForm() {
      this.model = new ChangePasswordModel();
    },

    closeModal() {
      this.$emit('closeModal');
      this.resetForm();
    },

    async save() {
      if(this.$refs.form.validate()) {
        this.loading = true;
        try {
          await this.svc.changePassword(this.user.id, this.model.password);
          this.loading = false;
          this.closeModal();
        } catch (error) {
          this.processErrorWithForm(error, {
            redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
            formErrors: this.formErrors,
            apiAttributes: this.model._apiAttributes
          });
          this.loading = false;
        }
      }
    }
  }

}
</script>
